import { memo } from "react";
import { useNavigate } from "react-router-dom";
const GridTile = ({ data, keyWord }: any) => {
  const nav = useNavigate();
  const onClickCard = () => {
    sessionStorage.setItem("lastPosition", window.scrollY.toString());
    nav(`/${keyWord}/${data.id}`);
  };
  let image =
    "https://imagedelivery.net/OsJkSw9Sjt8i9jgP9HvzGw/aa080608-d89d-4d7f-39cf-1c41bfc22c00/public";

  if (data && data.images && data.images.length !== 0) {
    image = data.images[0].url;
  }

  return (
    <div
      className="bg-white rounded-xl shadow hover:shadow-lg transition-shadow cursor-pointer flex flex-col items-stretch p-0 h-full min-h-[340px] max-w-xs mx-auto"
      onClick={onClickCard}
      style={{ minHeight: 340 }}
    >
      <div className="w-full aspect-[3/4] bg-gray-100 overflow-hidden rounded-t-xl flex-shrink-0">
        <img
          src={image}
          alt={data.name}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex flex-col justify-center p-4 text-left flex-1">
        <span className="text-lg font-bold mb-1 text-gray-900 line-clamp-1">
          {data.name}
        </span>
        {data.workers && (
          <span className="text-sm text-gray-500 mt-1 line-clamp-1">
            {data.workers}
          </span>
        )}
      </div>
    </div>
  );
};

export default memo(GridTile);
